<template>
    <kb-container fluid class="no-padding bottom-padding">
        <div class="vertical-padding">
            <kb-button variant='default' v-if="totalPages > 1" @click="loadPreviousPage">&larr;</kb-button>
            <span class='small-left-margin small-right-margin'><kb-form-select @change='loadSelectedPage' v-model='currentPageNumberCopy' :options="pageNumberSelectOptions" v-if="totalPages > 1" class="inline-auto-width" /></span>
            <kb-button variant='default' v-if="totalPages > 1" @click="loadNextPage">&rarr;</kb-button>
            {{totalResults}}&nbsp;documents&nbsp;found
        </div>

        <div>
            <div :key='document.ID' v-for="document in documentsList">
                    <router-link :to='buildDocumentDetailUrl(document)' :title='"View " + document.Title + " Item Details"' >
                        ({{ document.DocumentTypeName }}) {{ document.Title }}
                    </router-link>
                <br/>
                <span style='font-style: italic'>{{ document.AuthorName }}</span>
                {{ document.PubName}} {{ document.DateVolumeIssue }} {{ document.Language }}
                <hr/>
            </div>
        </div>

        <div class="vertical-padding">
            <kb-button variant='default' v-if="totalPages > 1" @click="loadPreviousPage">&larr;</kb-button>
            <span class='small-left-margin small-right-margin'><kb-form-select @change='loadSelectedPage' v-model='currentPageNumberCopy' :options="pageNumberSelectOptions" v-if="totalPages > 1" class="inline-auto-width" /></span>
            <kb-button variant='default' v-if="totalPages > 1" @click="loadNextPage">&rarr;</kb-button>
            {{totalResults}}&nbsp;documents&nbsp;found
        </div>
    </kb-container>
</template>

<script>

import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'

export default {
    props: {
        itemsPerPage: {
            type: Number,
            required: true
        },
        currentPageNumber: {
            type: Number,
            required: true
        },
        documentsList: {
            type: Array,
            required: true
        },
        totalResults: {
            type: Number,
            required: true
        }
    },
    mixins: [urlsService, mediaService],
    data() {
        return {
            pageNumberSelectOptions: [],
            currentPageNumberCopy: 0
        }
    },
    methods: {
        onGoToPage(pageNum) {
            this.$emit('pageNumberChanged', { pageNumber: pageNum })
        },
        loadPageSelectOptions() {
            this.pageNumberSelectOptions = []
            let currentTotalPages = this.totalPages

            for (let c = 0; c < currentTotalPages; c++) {
                let prompt = 'Pg ' + (c + 1) + ' of ' + currentTotalPages
                this.pageNumberSelectOptions.push({ value: c, text: prompt })
            }
        },
        loadPreviousPage() {
            // console.log('in DocSearchResults loadPreviousPage')
            if (this.currentPageNumber > 0) {
                this.onGoToPage(this.currentPageNumber - 1)
            }
        },
        loadNextPage() {
            // console.log('in DocSearchResults loadNextPage')
            if (this.currentPageNumber < this.totalPages-1) {
                this.onGoToPage(this.currentPageNumber + 1)
            }
        },
        loadSelectedPage(pageValue) {
            this.onGoToPage(pageValue)
        },
        documentDetailPageUrl: function(document) {
            return this.buildDocumentDetailUrl(document)
        }
    },

    watch: {
        totalResults: function(val) {
            this.loadPageSelectOptions()
        },
        currentPageNumber: function() {
            this.currentPageNumberCopy = this.currentPageNumber // this avoids binding dropdowns to a property, which causes errors when they change
        }
    },

    computed: {

        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },

        totalPages: function() {
            if (this.totalResults === 0) {
                return 0 // 0 results means 0 pages
            }
            let totalPagesCount = Math.floor((this.totalResults-1) / this.itemsPerPage) + 1 // 1 to 50 results means 1 pages, etc...
            let partialPageItemsCount = this.totalResults - (totalPagesCount * this.itemsPerPage)

            if (partialPageItemsCount > 0) {
                totalPagesCount++
            }
            return totalPagesCount
        }
    }
}
</script>

<style>
</style>
